import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FavoriteStation } from '../../../interfaces/favorites/favorite-station.interface';

@Component({
    selector: 'app-favorite-station',
    templateUrl: './favorite-station.component.html',
    styleUrls: ['./favorite-station.component.scss'],
    standalone: false
})
export class FavoriteStationComponent {
  @Output() onEditButtonClick = new EventEmitter<void>();
  @Output() onDeleteButtonClick = new EventEmitter<void>();
  @Output() onPickFavoriteClick = new EventEmitter<void>();

  @Input() showActionButtons: boolean = false;
  @Input() station: FavoriteStation;
  /** a11y: accessible names for the pen/trash icon buttons (audit). */
  @Input() editAriaLabel: string = '';
  @Input() deleteAriaLabel: string = '';
}
